import React, { Component } from 'react';
import { Table } from 'antd';
import AdminCompaniesAddUserContainer from '../containers/AdminCompaniesAddUserContainer';

class AdminCompaniesDetailView extends Component {
    render() {
        const columns = [
            {
                title: 'User',
                dataIndex: 'key',
                key: 'key',
                // render: text => (new Date(text).toDateString()),
            },
            {
                title: 'Rol',
                dataIndex: 'type',
                key: 'type',
            },
        ];

        return (
            <div>
                <Table columns={columns} dataSource={this.props.users} />
                <AdminCompaniesAddUserContainer
                    companyid={this.props.companyid}
                />
            </div>
        );
    }
}

export default AdminCompaniesDetailView;



// WEBPACK FOOTER //
// ./src/components/views/AdminCompaniesDetailView.js